import { api } from '@creditsights/api-ui-web';
import { MarketStats, MarketAggregated, MarketRegion, MarketType } from '../models/Market';

export const fetchMarketStats = async (type: MarketType): Promise<MarketAggregated> => {
  const results = await Promise.all([fetchAggregatedMarketStats(type, MarketRegion.NA), fetchAggregatedMarketStats(type, MarketRegion.EU)]);

  return {
    na: results[0],
    eu: results[1],
  };
};

const fetchAggregatedMarketStats = async (type: MarketType, region: MarketRegion): Promise<MarketStats> => {
  const { data } = await api.get('document-upload/v1/market-stats/aggregated-data', {
    params: {
      region,
      type,
    },
  });

  return data;
};
